import { render, staticRenderFns } from "./DrChronoMenu.vue?vue&type=template&id=270b919c&scoped=true&"
import script from "./DrChronoMenu.vue?vue&type=script&lang=ts&"
export * from "./DrChronoMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270b919c",
  null
  
)

export default component.exports